import { ELabelTagType } from '@pu/mpp-ui/components/label-tag';
import {
  EPromotionConditionType,
  EPromotionDetailSubType,
  EPromotionDetailType,
  EPromotionSearchMethod,
  EPromotionStatus,
  EPromotionType,
} from 'core/model/enums';
import { IPromotionDetailRequest, IPromotionFiltersForm } from 'core/model/interfaces/promotions';

export const PROMOTION_GROUP_TITLE_MAX_LENGHT = 30;

export const PROMOTION_DESCRIPTION_MAX_LENGTH = 80;

export const PROMOTIONS_EMPTY_LIST_TEXT = 'Verifica los filtros aplicados o intenta con otros segmentos.';

export const PROMOTION_FILTERS_FORM_ATTRIBUTES: Record<keyof IPromotionFiltersForm, keyof IPromotionFiltersForm> = {
  ids: 'ids',
  sourceId: 'sourceId',
  status: 'status',
  rangeDate: 'rangeDate',
  isCustom: 'isCustom',
  subType: 'subType',
};

export const PROMOTIONS_FORM_ATTRIBUTES: Record<keyof IPromotionDetailRequest, keyof IPromotionDetailRequest> = {
  isActive: 'isActive',
  hasPreview: 'hasPreview',
  groupTitle: 'groupTitle',
  description: 'description',
  isDigitalExclusive: 'isDigitalExclusive',
};

export const PROMOTIONS_TAB = {
  [EPromotionSearchMethod.CODE]: 'Por código de promoción',
  [EPromotionSearchMethod.FILTER]: 'Por filtro',
};

export const PROMOTIONS_LABEL_TAG = {
  [EPromotionStatus.NEW]: {
    type: ELabelTagType.WARNING,
    text: 'Nuevo',
    highlight: true,
  },
  [EPromotionStatus.IN_PROGRESS]: {
    type: ELabelTagType.POSITIVE,
    text: 'En progreso',
    highlight: true,
  },
  [EPromotionStatus.PUBLISHED]: {
    type: ELabelTagType.POSITIVE,
    text: 'Publicado',
    highlight: false,
  },
};

export const PROMOTIONS_DETAIL_TYPE_ABBREVIATION = {
  [EPromotionDetailType.DISCOUNT]: 'Dsct.',
  [EPromotionDetailType.BONUS]: 'Bon.',
};

export const PROMOTIONS_DETAIL_TYPE = {
  [EPromotionDetailType.DISCOUNT]: 'Descuento',
  [EPromotionDetailType.BONUS]: 'Bono',
};

export const PROMOTIONS_DETAIL_SUBTYPE = {
  [EPromotionDetailSubType.SIMPLE]: 'Simple',
  [EPromotionDetailSubType.TIERED]: 'Escalonada',
  [EPromotionDetailSubType.COMBO]: 'Combo',
};

export const PROMOTIONS_CATEGORY = {
  [EPromotionDetailType.DISCOUNT]: {
    [EPromotionDetailSubType.SIMPLE]: EPromotionType.SIMPLE_DISCOUNT,
    [EPromotionDetailSubType.TIERED]: EPromotionType.TIERED_DISCOUNT,
    [EPromotionDetailSubType.COMBO]: EPromotionType.COMBO_DISCOUNT,
  },
  [EPromotionDetailType.BONUS]: {
    [EPromotionDetailSubType.SIMPLE]: EPromotionType.SIMPLE_BONUS,
    [EPromotionDetailSubType.TIERED]: EPromotionType.TIERED_BONUS,
    [EPromotionDetailSubType.COMBO]: EPromotionType.COMBO_BONUS,
  },
};

export const PROMOTIONS_CONDITION_TYPE = {
  [EPromotionConditionType.QUANTITY]: 'unidades',
  [EPromotionConditionType.AMOUNT]: 'soles',
};

export const PROMOTION_FILTERS_SOURCE_ID_INPUT = {
  name: PROMOTION_FILTERS_FORM_ATTRIBUTES.sourceId,
  labelText: 'ERP',
  placeholder: 'Elige las opciones',
  isMulti: true,
};

export const PROMOTION_FILTERS_STATUS_INPUT = {
  name: PROMOTION_FILTERS_FORM_ATTRIBUTES.status,
  labelText: 'Estados',
  placeholder: 'Elige las opciones',
  isMulti: true,
};

export const PROMOTION_FILTERS_RANGE_DATE_INPUT = {
  name: PROMOTION_FILTERS_FORM_ATTRIBUTES.rangeDate,
  labelText: 'Fecha de Inicio y Fin',
  placeholder: 'Elige las opciones',
};

export const PROMOTION_FILTERS_IS_CUSTOM_INPUT = {
  name: PROMOTION_FILTERS_FORM_ATTRIBUTES.isCustom,
  labelText: 'Personalización',
  placeholder: 'Elige las opciones',
  isMulti: true,
};

export const PROMOTION_FILTERS_SUBTYPE_INPUT = {
  name: PROMOTION_FILTERS_FORM_ATTRIBUTES.subType,
  labelText: 'Tipo de promoción',
  placeholder: 'Elige las opciones',
  isMulti: true,
};

export const PROMOTION_FILTERS_IDS_INPUT = {
  name: PROMOTION_FILTERS_FORM_ATTRIBUTES.ids,
  labelText: 'Código de promoción',
  placeholder: 'Buscar por código de promoción',
};
